import { createSlice } from '@reduxjs/toolkit';

export const ShowCookiesSlice = createSlice({
	name: 'showCookies',
	initialState: {
		isShown: true,
		isCookiesModalExpanded: false,
		isAnalyticsAccepted: false,
	},
	reducers: {
		setShowCookies: (state, action) => {
			state.isShown = action.payload;
		},
		setIsCookiesModalExpanded: (state, action) => {
			state.isCookiesModalExpanded = action.payload;
		},
		setIsAnalyticsAccepted: (state, action) => {
			state.isAnalyticsAccepted = action.payload;
		},
	},
});

export const { setShowCookies, setIsCookiesModalExpanded, setIsAnalyticsAccepted } = ShowCookiesSlice.actions;

export default ShowCookiesSlice.reducer;